import React from 'react';
import Todos from './components/Todos';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer'
import AddTodo from './components/AddTodo';
import './App.css';
import uuid from 'uuid';

class App extends React.Component {

  state= {
    todos: [
      /*{
        id: uuid.v4(),
        title: 'Ma première tâche (exemple)',
        completed: false
      }*/
      /*{
        id: uuid.v4(),
        title: 'Vérifier ma boite mail',
        completed: false
      },
      {
        id: uuid.v4(),
        title: 'Application REACT',
        completed: false
      },
      {
        id: uuid.v4(),
        title: 'Concept Art',
        completed: false
      }*/
    ]
  }

  // Méthodes:
  changeCompletedState = (id) => {
    this.setState(
      {
        todos : this.state.todos.map((todo) => {
          if(todo.id === id){
            todo.completed = !todo.completed;
          }
          return todo;
        })
      }
    );
  }

  delTodo = (id) => {
    this.setState(
      {
        todos: this.state.todos.filter((todo) =>
          id !== todo.id
        )
      }
    );
  }

  addTodo = (title) => {
    const newTodo = {
      id : uuid.v4(),
      title : title,
      completed : false
    }
    this.setState({todos: [...this.state.todos, newTodo]});
  }

  // Render :
  render(){
      return (
        <div className="App">
          <Header/>
          <div className="conteneur_page">
            <AddTodo addTodo={this.addTodo} />
            <Todos todos={this.state.todos} changeCompletedState={this.changeCompletedState} delTodo={this.delTodo}/>
          </div>
          <Footer/>
        </div>
      );
  }
  
} 

export default App;
